/* eslint-disable consistent-return */
import { apileads } from '../enviroment/apileads';

const getMarcas = async () => {
  const response = await apileads.get('/v1/marcas');
  try {
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.log('Error get List ');
  }
};

export {
    getMarcas,
};
